var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { useState, useCallback } from 'react';
import sendToLurker from '../../Lurker';
export const useLoadNotificationsBadge = () => {
  const [notifications, setNotifications] = useState(0);
  const loadNotificationsBadge = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
    try {
      const headers = new Headers();
      headers.set('x-olx-team-key', '5XzjuCgmYE7qMlYpsLZbTvm98ik4CS4a');
      headers.set('Cache-Control', 'no-cache');
      const request = yield fetch('https://apigw.olx.com.br/badge/notifications', {
        credentials: 'include',
        headers
      });
      const response = yield request.json();
      if (!response.central) return 0;
      setNotifications(response.central);
      sendToLurker({
        eventType: 'impression',
        objectDetail: 'badge',
        objectName: 'notification'
      });
    } catch (error) {
      // TODO Improvement: enviar log de erro ao Sentry
    }
  }), []);
  return [notifications, loadNotificationsBadge];
};